import { render, staticRenderFns } from "./TokensEditor.vue?vue&type=template&id=14c4fca6"
import script from "./TokensEditor.vue?vue&type=script&lang=js"
export * from "./TokensEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports